export class dataSearchChart {
    practice: any = null;
    provider: any = null;
    patient: any = null;
    dateFrom: any = null;
    dateTo: any = null;
    timezone: any = null;
    type:any = null;
    event_reason_id: any = null;
}